import { register } from "./registry";

/**
 * A-D6: picking a post-dated cheque (ChequePicker.cs) fills the voucher's fields named in the option's data-fill (Remarks, Amount,
 * cheque no./miti, bank account), as CargoBooks does. A journal fills its own row instead (journal-voucher.ts).
 */
register((root) => {
  root.querySelectorAll<HTMLFormElement>("form[data-kit-form]:not([data-journal-voucher])").forEach((form) => {
    if (form.dataset.pdcPickBound === "1") return;
    form.dataset.pdcPickBound = "1";
    form.addEventListener("change", (e) => {
      const pick = e.target;
      if (!(pick instanceof HTMLSelectElement) || !pick.hasAttribute("data-pdc-pick")) return;
      const fill = pick.selectedOptions[0]?.dataset.fill;
      if (!fill) return;
      for (const [name, value] of Object.entries(JSON.parse(fill) as Record<string, string>)) {
        const field = form.querySelector<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(`[name='${name}']`);
        if (!field) continue;
        field.value = value;
        field.dispatchEvent(new Event("input", { bubbles: true }));
        field.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });
});
